import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const CityInput = ({ required = true, helperText = null }) => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("city")}
      placeholder={t("city")}
      type="text"
      id="city"
      autoComplete="city"
      required={required}
      helperText={helperText}
    />
  );
};
export default CityInput;
